import Vue from 'vue';

export function Permissions() {
    Vue.permissions = {
        view(user, permission) {
            const userPermissions = user.permissions;
            if (userPermissions.includes('*')) {
                return true;
            }
            return userPermissions.includes(permission);
        },

        viewAny(user, permissions) {
            const userPermissions = user.permissions;
            if (userPermissions.includes('*')) {
                return true;
            }
            return permissions.some(permission => userPermissions.includes(permission));
        }
    };

    Object.defineProperties(Vue.prototype, {
        $can: {
            get() {
                return Vue.permissions;
            }
        }

    });
}